var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0418 0.585786C25.2608 -0.195262 23.9945 -0.195262 23.2134 0.585787L13.3138 10.4854L3.41421 0.585789C2.63316 -0.195259 1.36683 -0.195259 0.585786 0.585789C-0.195262 1.36684 -0.195262 2.63317 0.585787 3.41422L10.4854 13.3138L0.585997 23.2132C-0.195051 23.9943 -0.195051 25.2606 0.585997 26.0416C1.36705 26.8227 2.63338 26.8227 3.41442 26.0416L13.3138 16.1422L23.2132 26.0416C23.9943 26.8227 25.2606 26.8227 26.0416 26.0416C26.8227 25.2606 26.8227 23.9943 26.0416 23.2132L16.1422 13.3138L26.0418 3.41421C26.8229 2.63316 26.8229 1.36683 26.0418 0.585786Z",
    fill: "#373473"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelLesson);
export default __webpack_public_path__ + "static/media/cancel_lesson.5df947c29cf2cfbb439064141c3e6891.svg";
export { ForwardRef as ReactComponent };